import { useState, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {
  __experimentalHStack as HStack,
  __experimentalText as Text,
  Button,
  Popover,
} from '@wordpress/components';
import {
  arrowLeft,
  arrowRight,
  chevronLeft,
  chevronRight,
  lock,
} from '@wordpress/icons';

const IconPicker = ({ label, Icon, onIconSelect }) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const [popoverAnchor, setPopoverAnchor] = useState();
  const [selectedIcon, setSelectedIcon] = useState(Icon);

  // Ensure state syncs with prop if `Icon` changes
  useEffect(() => {
    setSelectedIcon(Icon || 'none');
  }, [Icon]);

  const togglePopover = () => {
    setIsPopoverVisible((prev) => !prev);
  };

  const handleIconClick = (icon) => {
    setSelectedIcon(icon);
    onIconSelect(icon); // Update parent with selected icon
    setIsPopoverVisible(false); // Close the popover after selecting
  };

  const iconOptions = [
    { label: __('None', 'vayu-blocks'), value: 'none', icon: lock }, // Placeholder for no icon
    { label: __('Arrow Left', 'vayu-blocks'), value: 'arrowLeft', icon: arrowLeft },
    { label: __('Arrow Right', 'vayu-blocks'), value: 'arrowRight', icon: arrowRight },
    { label: __('Chevron Left', 'vayu-blocks'), value: 'chevronLeft', icon: chevronLeft },
    { label: __('Chevron Right', 'vayu-blocks'), value: 'chevronRight', icon: chevronRight },
    
  ];

  const selectedOption = iconOptions.find((option) => option.value === selectedIcon);
  const iconDisplay = selectedOption ? selectedOption.icon : lock;

  return (
    <div className="vayu_blocks_icon_picker_panel">
      {label && <Text className="icon-picker-label">{label}</Text>}
     
      <Button
        ref={setPopoverAnchor}
        onClick={togglePopover}
        className={`block-editor-panel-icon-settings__dropdown ${
          isPopoverVisible ? 'is-open' : ''
        }`}
      >
        <HStack alignment="left">
          <span className="icon-display" style={{ fontSize: '1.3rem' }}>
            {iconDisplay}
          </span>
          <Text>{selectedOption ? selectedOption.label : __('None', 'vayu-blocks')}</Text>
        </HStack>
      </Button>

      {isPopoverVisible && (
        <Popover
          placement="left-start"
          className="vayu_blocks_toolspanel_items_popover"
          anchor={popoverAnchor}
          onClose={() => setIsPopoverVisible(false)}
          offset={35}
          resize
        >
          <div className="vayu_blocks_icon_picker">
            <h4>{__('Select Icon')}</h4>
            <p>{__('Choose an icon for your element or select "None".')}</p>
            <div className="vayu-blocks-icon-picker-grid">
              {iconOptions.map((option) => (
                <div
                  key={option.value}
                  className={`vayu_blocks-icon-option ${
                    selectedIcon === option.value ? 'selected' : ''
                  }`}
                  onClick={() => handleIconClick(option.value)}
                  title={option.label}
                >
                  <span className="icon-display">{option.icon}</span>
                </div>
              ))}
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default IconPicker;